import i18n from "i18next";
import { initReactI18next } from "react-i18next";

/* i18n configuration */
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {},
    },

    fr: {
      translation: {
        Select: "Sélectionner",
        "Select a vessel": "Sélectionner un navire",
        Validate: "Valider",
        Rename: "Renommer",
        "Add your currency (3 characters)":
          "Ajoutez votre devise (3 caractères)",
        Save: "Enregistrer",
        "Contracts management": "Gestion des contrats",
        Contracts: "Contrats",
        Dashboard: "Administration",
        Companies: "Sociétés",
        Brokers: "Brokers",
        Documents: "Notices",
        Logout: "Déconnexion",
        "Templates list": "Liste des templates",
        Edit: "Modifier",
        Fields: "Champs",
        Name: "Nom",
        Type: "Type",
        Label: "Label",
        Required: "Requis",
        No: "Non",
        "Edit template view": "Editer le rendu d'un template",
        "Edit contract": "Modifier un contrat",
        "ECPY Agreement unique number": "Numéro d'identification unique ECPY",
        "This field has been auto-generated":
          "Ce champ a été généré automatiquement",
        "Date of signature of Agreement": "Date du contrat",
        Place: "À",
        "The Client": "Le Client",
        "The Service Provider": "Le Prestataire",
        "Information about the vessel": "Renseignements relatifs au navire",
        "Name of the vessel": "Nom du navire",
        "IMO number": "N° IMO",
        "Port of registry": "Port d'attache",

        Flag: "Pavillon",
        "Type of Yacht": "Type",
        "Yacht LOA in meters": "Longueur hors tout en mètres",
        Address: "Adresse",
        "Date of agreement": "Date du contrat",
        in: "à",
        BETWEEN: "ENTRE",
        'Hereinafter the "Client"': 'Ci-après désigné "le Client"',
        'Hereinafter the "Service Provider"':
          'Ci-après désigné "le Prestataire"',
        AND: "ET",
        'Jointly the "Parties"':
          'Tous deux désignés ensemble comme "les Parties"',
        "In consideration of the mutual undertakings contained herein, the Parties agree to the following":
          "Les parties conviennent des engagements suivants.",
        "You are currently editing page":
          "Vous êtes en train de modifier la page",
        Next: "Suivante",
        Previous: "Précédente",
        "Details of the parties":
          "Renseignements relatifs aux opérateurs du contrat",
        "DETAILS OF THE PARTIES":
          "RENSEIGNEMENTS RELATIFS AUX OPERATEURS DU CONTRAT",
        "Client Address": "Adresse du client",
        "Client Address 2": "Adresse du client 2",
        "Client Address 3": "Adresse du client 3",
        "Service Provider Address 1": "Adresse du prestataire",
        "Service Provider Address 2": "Adresse du prestataire 2",
        "Service provider Company ID": "Prestataire - Identif. Prof. Société",
        "Service provider VAT reference": "Prestataire - n° TVA",
        "Service provider insurance reference": "Prestataire - assurance",
        "Central agent": "Agent central",
        PROVIDER: "PRESTATAIRE",
        "Central Agent Address": "Agent central adresse",
        "Central Agent Address 2": "Agent central adresse 2",
        "Central Agent Company ID": "Agent central Identif.Prof.Société",
        "Central agent VAT number": "Agent central N° TVA",
        "Central agent MYBA Registration": "Agent central - Ref. MYBA",
        Stakeholder: "Séquestre",
        "Stakeholder address": "Séquestre adresse",
        "Stakeholder address 2": "Séquestre adresse 2",
        "Stakeholder company ID": "Séquestre Identif.Prof.Société",
        "Stakeholder MYBA id": "Séquestre ref.MYBA",
        "Stakeholder VAT number": "Séquestre N° TVA",
        "Stakeholder insurance reference": "Séquestre Assurance",
        "Stakeholder financial guarantee": "Séquestre Garantie financière",
        "Check the document": "Vérifier le document",
        "Validate final contract": "Valider le contrat final",
        "The Charterer": "L'affréteur",
        "Download the PDF": "Télécharger le PDF",
        "Download the full PDF": "Télécharger le PDF complet",
        Loading: "Chargement",
        "You can save draft anytime you want":
          "Vous pouvez sauvegarder les informations quand vous voulez",
        Informations: "Informations",
        Zipcode: "Code postal",
        City: "Ville",
        Country: "Pays",
        "Registration Number": "Numéro d'enregistrement",
        "Registration Country": "Pays d'enregistrement",
        "VAT Number": "Numéro TVA",
        Insurance: "Assurance",
        "Financial Guarantee": "Garantie financière",
        Update: "Modifier",
        "Go back": "Retour",
        "Tokens management": "Gestion des tokens",
        "Company subscription is valid until this date":
          "L'abonnement de la société est valide jusqu'à la date suivante",
        "Available tokens": "Tokens disponibles",
        "Consumed tokens": "Tokens consommés",
        Firstname: "Prénom",
        Email: "Email",
        Main: "Référent",
        "Broker has been updated": "Le courtier a été modifié",
        "Broker has been added": "Le courtier a été ajouté",
        "Company is mandatory": "La courtier est obligatoire",
        "Add broker": "Ajouter un courtier",
        "Update broker": "Modifier un courtier",
        active: "Actif",
        yes: "oui",
        deactivated: "Désactivé",
        "Activate account": "Activer le compte",
        "De-activate account": "Désactiver le compte",
        Statistics: "Statistiques",
        "Your private key": "Votre clé privée",
        Add: "Ajouter",
        "Your contracts": "Vos contrats",
        "This Agreement was signed on": "Ce contrat a été signé le",
        "This Agreement was created on": "Ce contrat  a été créé le",
        "Your company": "Votre société",
        "You're attached to the company": "Vous êtes rattaché à la société",
        "My contracts": "Mes contrats",
        Show: "Voir",
        "My account": "Mon compte",
        "My Account": "Mon Compte",
        "Update my password": "Modifier mon mot de passe",
        "Update your password": "Modifier votre mot de passe",
        "Your password should have at least 8 characters, with at least 1 digit and 1 special character":
          "Votre mot de passe doit contenir au moins 8 caractères, avec au moins 1 chiffre et un caractère spécial",
        "New password": "Nouveau mot de passe",
        "Confirm password": "Confirmez le mot de passe",
        "8 characters mini, 1 digit, 1 special character":
          "8 caractères minimum, 1 chiffre, 1 caractère spécial",
        "Passwords have to be the same":
          "Les mots de passe doivent être identiques",
        "Your password should have 8 characters minimum":
          "Votre mot de passe doit contenir au moins 8 caractères",
        "Your password should contain at least one digit":
          "Votre mot de passe doit contenir au moins 1 chiffre",
        "Your password should contain at least one of this characters":
          "Votre mot de passe doit contenir au moins un de ces caractères",
        "Generate your crypt keys": "Générer vos clés de chiffrement",
        "Your password has been updated, you are now going to generate your crypt keys. Your private key allows you to secure your contract's data, and should be safely kept.":
          "Votre mot de passe a été mis à jour, vous allez désormais générer vos clés de chiffrement. Votre clé privée vous permettra de sécuriser les données de vos contrats, et doit être conservée de manière sécurisée.",
        "Generate my crypt keys": "Générer mes clefs de chiffrement",
        "WARNING : resetting your keys means that you won't be able to access your current contract's data anymore. This action can't be reversed !":
          "ATTENTION : en réinitialisant vos clés de sécurité, vos contrats en cours ne seront plus accessibles... Cette action ne peut pas être annulée !",
        End: "Terminer",
        "Your keys have been generated, find your private key below":
          "Vos clés de chiffrement ont bien été générées. Voici ci-dessous votre clé privée",
        warning: "attention",
        "kept it safe because you won't be able to access your data if you loose it":
          "conservez la bien car vous ne pourrez plus accéder aux données de vos contrats en cas de perte",
        "INFORMATION ABOUT THE VESSEL": "RENSEIGNEMENTS RELATIFS AU NAVIRE",
        "Name of Vessel": "Nom du navire",
        "This Agreement has been signed": "Le présent Contrat a été signé",
        //"Flag": "Pavillon",
        "Overall length": "Longueur Hors Tout",
        meters: "mètres",
        "Service Provider": "Prestataire",
        "Registered Office Address": "Adresse",
        "Company registration and country of incorporation":
          "Identif.prof.société",
        "VAT N°": "N° TVA",
        Broker: "Courtier",
        "MYBA Ref": "Ref. MYBA",
        "Financial guarantee": "Garantie financière",
        "CRUISE PARTICULARS": "PERIODE, LIEUX ET NAVIGATION",
        "From (date and time)": "Du (jour et heure)",
        "To (date and time)": "Au (jour et heure)",
        "Port of embarkation": "Port d'embarquement",
        "Port of disembarkation": "Port de débarquement",
        "Port of delivery": "Port de pré-acheminement",
        "Port of redelivery": "Port de post-acheminement ",
        "Cruising area": "Zone de navigation",
        "Scheduled itinerary cf. Appendix I":
          "Itinéraire programmé cf. Annexe I",
        "Scheduled itinerary": "Itinéraire programmé",
        "cf. Appendix I": "cf. Annexe I",
        "Total hours of navigation": "Durée de navigation",
        "hours (vessel underway)": "heures (navire en route)",
        "Maximum number of Passengers with staterooms":
          "Nombre maximum de Passagers logeant avec couchette",
        "and day Passengers on board": "et de Passagers embarqués non logeant",
        "International voyage": "Voyage international",
        "Voyage outside territorial waters": "Voyage hors eaux territoriales",
        "Voyage 100% territorial waters": "Voyage 100% en eaux territoriales",
        "SERVICE PACKAGE PRICE (CLAUSES 12 TO 16)":
          "PRIX DE LA PRESTATION (CLAUSES 12 à 16)",
        "Agreement currency": "Devise du contrat",
        "Total price for Service Package - Voyage, Services and Accommodation":
          "Prix total de la Prestation / Voyage et Hébergement forfaitaires",
        "EXCL VAT": "HORS TVA",
        "VAT rate": "Taux de TVA",
        "VAT amount": "Montant de la TVA",
        "INC VAT": "TTC",
        "Advance provisioning allowance": "Avance sur frais",
        "Security deposit": "Dépôt de garantie",
        "TERMS OF PAYMENT": "MODALITES DE VERSEMENT",
        "First instalment": "Premier versement",
        "Second instalment": "Deuxieme versement",
        "Third instalment": "Troisième versement",
        "Due date": "Date de versement",
        "BANK TRANSFER DETAILS": "DONNEES BANCAIRES EN VUE DU VIREMENT",
        Bank: "Banque",
        "Bank Name": "Banque",
        IBAN: "IBAN",
        SWIFT: "SWIFT",
        LANGUAGE: "LANGUE",
        "This Agreement is provided in English, with a non-official version in French being available. In case of a dispute regarding the interpretation of Agreement, the sole English version, included its appendices, is regarded as the legal reference of Agreement. \n In keeping with contemporary usage, in this Agreement, the question of the gender of the Charterer, Owner and Captain is addressed by the use of they, their, them as the singular, non-gendered equivalent of he / she, his / her, him / her.":
          "Ce contrat est fourni en français, une version non officielle en anglais étant disponible. En cas de litige concernant l'interprétation du Contrat, la seule version française, y compris ses annexes, est considérée comme la référence juridique du Contrat.",
        "SPECIAL CONDITIONS": "CONDITIONS PARTICULIERES",
        "The scope of services is set out in Appendix II and in the special conditions below.":
          "Les prestations sont définies par l'Annexe II jointe et par les éléments particuliers ci-dessous.",
        "The price for the services listed below is included in the above Price of the Service Package.":
          "Les prix des prestations particulières citées ci-dessous sont inclus dans le Prix de la Prestation page ci-dessus.",
        SIGNATURES: "SIGNATURES",
        "The Service Provider and the Client hereby agree that the attached Appendices I (itinerary and Passenger list), II (vessel and scope of services), III (General Sales Conditions, clauses 1 to 29 inclusive), and any/all Special Conditions set out above are an integral part of this Agreement. This Agreement is binding upon signature by the Parties. Signatures provided by fax/email, or in a PDF document sent via email, constitute a legal and enforceable obligation for said signatory having the same force and effect as if this Agreement were an original, irrespective of the original jurisdiction of the Agreement.":
          "Le Prestataire et le Client conviennent que les Annexes jointes, I (itinéraire et liste des Passagers), II (prestations), III (Conditions générales de vente, clauses 1 à 29 comprises), ainsi que les Conditions Particulières éventuelles ci-dessus font partie intégrante du Contrat. Le présent Contrat, une fois signé, lie les Parties. Dans le cas d'une signature transmise par télécopie/e-mail, ou en fichier PDF envoyé par courrier électronique, ladite signature constitue une obligation légale et exécutoire pour la partie exécutant ayant la même force et le même effet que si ce Contrat était un original, indépendamment de la juridiction d'origine du Contrat.",
        "ADDITIONAL INSURANCE": "ASSURANCES COMPLEMENTAIRES",
        "I hereby declare that I have been informed about the additional luggage, assistance and cancellation insurance proposed and that I do not wish to take out such insurance":
          "Je déclare avoir été informé des assurances complémentaires bagages, assistance et annulation proposées et ne pas souhaiter y souscrire",
        "I hereby declare that I wish to take out the following additional insurance":
          "Je déclare souscrire aux assurances complémentaires",
        Charterer: "Affréteur",
        Hereinafter: "Ci-après",
        Owner: "l'Armateur",
        "PRICE OF CHARTER": "PRIX DE L’AFFRÈTEMENT",
        "Charter Fee":
          "Prix total de l’Affrètement / Voyage et Hébergement forfaitaires",
        "Total price for charter":
          "Prix total de l’Affrètement / Voyage et Hébergement forfaitaires",
        "Delivery/Redelivery fees": "Frais de pre/post-acheminement",
        Language: "Langue",
        "This Agreement is provided in English, with a non-official version in French being available. In case of a dispute regarding the interpretation of Agreement, the sole English version, included its appendices, is regarded as the legal reference of Agreement. In keeping with contemporary usage, in this Agreement, the question of the gender of the Charterer, Owner and Captain is addressed by the use of they, their, them as the singular, non-gendered equivalent of he / she, his / her, him / her.":
          "Ce Contrat est fourni en français, une version non officielle en anglais étant disponible. En cas de litige concernant l'interprétation du Contrat, seule la version française, y compris ses annexes, est considérée comme la référence juridique du Contrat.",
        Luggage: "Bagages",
        Assistance: "Assistance",
        Cancellation: "Annulation",
        "I hereby declare that I have read, understood and agree to all the terms of this Agreement, its conditions and appendices":
          "Je déclare avoir lu, compris et accepter l'ensemble des termes du contrat, de ses conditions et de ses annexes",
        'Represented by "name, capacity of signatory, full address", duly authorised as the Client\'s representative for the signature of this Agreement':
          'représenté par "nom, qualité du signataire, adresse complète", dûment habilité à représenter celui-ci pour la signature du présent document',
        'Represented by "name, capacity of signatory, full address", duly authorised as the Service Provider\'s representative for signature of this Agreement':
          'représenté par "nom, qualité du signataire, adresse complète", dûment habilité à représenter celui-ci pour la signature du présent document',
        'Represented by "name, capacity of signatory, full address", duly authorised as the Broker\'s representative for signature of this Agreement':
          'représenté par "nom, qualité du signataire, adresse complète", dûment habilité à représenter celui-ci pour la signature du présent document',
        'Represented by "name, capacity of signatory, full address", duly authorised as the Central agent\'s representative for signature of this Agreement':
          'représenté par "nom, qualité du signataire, adresse complète", dûment habilité à représenter celui-ci pour la signature du présent document',
        'Represented by "name, capacity of signatory, full address", duly authorised as the Stakeholder\'s representative for signature of this Agreement':
          'représenté par "nom, qualité du signataire, adresse complète", dûment habilité à représenter celui-ci pour la signature du présent document',
        Close: "Fermer",
        "Total price for Service Package - Voyage, Services and Accommodation (EXCL VAT)":
          "Prix total de la Prestation / Voyage et Hébergement forfaitaires - TVA exclue",
        "VAT rate (%)": "Taux de TVA (%)",
        "Total price for Service Package - Voyage, Services and Accommodation (INCL VAT)":
          "Prix total de la Prestation / Voyage et Hébergement forfaitaires - TTC",
        "Security Deposit": "Dépôt de garantie",
        "Total amount of payment": "Montant total à payer",
        "First installment amount": "Premier versement montant",
        "First installment date": "Premier versement date",
        "Second installment amount": "Second versement montant",
        "Second installment date": "Second versement date",
        "Third installment amount": "Troisième versement montant",
        "Third installment date": "Troisième versement date",
        "Bank Address 1": "Adresse de la banque 1",
        "Service package price (clauses 12 to 16)":
          "Prix de la prestation (clauses 12 à 16)",
        "Terms of payment": "Modalités de paiement",
        "Bank transfer details": "Données bancaires en vue du virement",
        "Bank IBAN": "IBAN",
        "Bank SWIFT": "SWIFT",
        "Special conditions": "Conditions particulières",
        "Additional insurance": "Assurance complémentaire",
        DRAFT: "BROUILLON",
        "Broker's statistics": "Statistiques courtiers",
        "Companie's statistics": "Statistiques entreprises",
        "Contract's statistics": "Statistiques contrats",
        "brokers registered": "courtiers inscrits",
        "companies registered": "entreprises inscrites",
        "contracts made": "contrats créés",
        "New company has been added": "La nouvelle société a bien été ajoutée",
        "ECPY Transport and services agreement for Yachts - Version 3.0_10 March 2022":
          "Contrat de transport et de prestation au Yachting d'ECPY-FR - Version 3.0_10 Mars 2022",
        "Welcome to the ECPY transport and charter agreements platform":
          "Bienvenue sur la plateforme Contract de transport ECPY",
        "for more informations contact": "pour plus d'informations contacter",
        "is set": "est renseignée",
        "Cruise from (date)": "Croisière du (date)",
        "Cruise from (time)": "Croisière du (heure)",
        "Cruise to (date)": "Croisière à (date)",
        "Cruise to (time)": "Croisière à (heure)",
        "Port of call": "Port",
        "Date of Arrival": "Date d'arrivée",
        "Time of Arrival": "Horaire d'arrivée",
        "Date of Departure": "Date de départ",
        "Time of departure": "Horaire de départ",
        "Cruise particulars": "Définition de la navigation",
        Itinerary: "Itinéraire",
        "Maximum number of Passengers on board":
          "Nombre maxium de passagers à bord",
        "Service package price": "Prix de la prestation",
        "All inclusive price (EXCL VAT)":
          "Prix forfaitaire du voyage (hors TVA)",
        "All inclusive price (INCL VAT)": "Prix total (TTC)",
        "Catering on board": "Restauration à bord",
        "Means of payment": "Moyen de paiement",
        "Account name": "Nom du compte",
        "Same as Central Agent": "Le même que l'agent central",
        "Welcome to ECPY agreement platform":
          "Bienvenue sur la plateforme contrat ECPY",
        "ECPY Transport And Charter Agreements Platform":
          "Plateforme contrat ECPY",
        "Please use your credentials to enter the platform.":
          "Merci de renseigner votre email et mot de passe afin de vous connecter sur la plateforme.",
        "Check contract": "Vérifier contrat",
        Home: "Accueil",
        "About ecpy.org": "À propos d'ECPY",
        "To view or add contracts, please set your private key":
          "Pour voir ou modifier vos contrats, merci de renseigner votre clé privée",
        "Add contract": "Ajouter un contrat",
        "Delete contract": "Supprimer le contrat",
        "This agreement has been generated by ECPY transport and charter agreements platform.":
          "Cet accord a été généré par la plate-forme d'accord de transport ECPY.",
        Status: "Statut",
        Lang: "Langue",
        Share: "Partager",
        Delete: "Supprimer",
        "Share has been removed": "Le partage a été supprimée",
        "See / Modify": "Consulter / Modifier",
        "Shared with": "Partagé avec",
        "WARNING ! This action cannot be undone.":
          "Attention ! Cette action ne peut pas être annulée.",
        "To add a new contract, you must give it a name. It would be used as a reference, and never shown to your client":
          "Pour ajouter un nouveau contrat, vous devez lui donner un nom. Il serait utilisé comme référence, et jamais montré à votre client",
        Draft: "Brouillon",
        valid: "Valide",
        invalid: "Non valide",
        "Validate draft": "Valider le brouillon",
        "Create the full PDF": "Créer le PDF complet",
        "Validate your draft": "Valider votre brouillon",
        "WARNING ! This action cannot be undone. You won't be able to edit this contract anymore, unless you go back to draft. You will need another token to validate again.":
          "ATTENTION ! Cette action ne peut pas être annulée. Vous ne pourrez plus modifier ce contrat, à moins de revenir en mode brouillon. Vous aurez besoin d'un nouveau token pour valider à nouveau.",
        "Do you wish to continue ?": "Voulez vous continuer ?",
        "Base contract (Day)": "Contrat de base (à la journée)",
        "Warning ! Tokens will be consumed when you validate your contract again after ending your draft.":
          "Attention ! Des tokens vont être consumés quand vous validerez à nouveau votre contrat.",
        "Addendums (Day)": "Annexes (Journée)",
        "Address 1": "Adresse 1",
        "Address 2": "Adresse 2",
        "Central Agent Insurance": "Assurance de l'agent central",
        "Add a change": "Ajouter un changement",
        Change: "Changement",
        Contract: "Contrat",
        "Base contract (Standard)": "Contrat de base (standard)",
        "Rider agreement": "Feuille de route",
        "Passenger list": "Liste des passagers",
        Addendum: "Avenant",
        "Addendum to the transport and services agreement for yachts":
          "Avenant au contrat",
        "Agency agreement for yachting services":
          "Mandat d'intermédiaire de prestation au yachting",
        "The principal": "Le mandant",
        Principal: "Mandant",
        "Status of the Principal": "Statut du mandant",
        owner: "propriétaire",
        charterer: "affréteur",
        'Hereinafter the "Charterer"': " Ci-après désigné l'affréteur",
        OWNER: "PROPRIETAIRE",
        CHARTERER: "AFFRÉTEUR",
        "Maximum number of Passengers in Port  (":
          "Nombre maximum de passagers dans le port  (",
        "Static charter": "Charter à quai",
        'Hereinafter the "Owner"': "Ci-après désigné l’armateur",
        "CHARTER AGREEMENT FOR YACHTS": "CONTRAT DE CHARTER POUR LES YACHTS",
        "Cost of pre/post Delivery": "Frais de mobilisation/démobilisation",
        "The Parties agree that the Special Conditions, the General Conditions and the Appendices form an integral part of the Contract. The provisions of the Contract shall be brought to the attention of the Charterer prior to any contractual commitment and this Contract shall constitute, prior to its signature by the Charterer, the prior information required by European regulations, their national transpositions or any equivalent regulations. Charterer is furthermore responsible for his Guests and is obliged to inform them of the terms of this Agreement, in particular of the contents of Articles 7, 10, 11 and 12 of the General Conditions.The Broker, the Central Agent and the Receiver are not parties to this Agreement and their signature only attests to the fact that they are aware of its existence and contents. Their involvement is governed by other contractual documents.This Agreement, once signed, is binding on the Parties. In the case of a signature transmitted by facsimile/e-mail, or as a PDF file sent by electronic mail, such signature shall constitute a legal and binding obligation of the executing party with the same force and effect as if this Agreement were an original.":
          "Les Parties conviennent que les Conditions Particulières, les Conditions Générales et les Annexes font partie intégrante du Contrat. Les stipulations du Contrat sont portées à la connaissance de l'Affréteur avant tout engagement contractuel et le présent Contrat constitue, avant sa signature par l'Affréteur, l'information préalable exigée par la réglementation européenne, ses transpositions nationales ou toute règlementation équivalente. L'Affréteur est par ailleurs responsable de ses Invités et est tenu de les informer des termes du présent Contrat, en particulier du contenu des Articles 7, 10, 11 et 12 des Conditions Générales. Le Courtier, l'Agent Central et le Séquestre ne sont pas partie au présent Contrat et leur signature n'atteste que du fait qu'ils sont informés de son existence et de son contenu. Leur intervention est régie par d'autres documents contractuels. Le présent Contrat, une fois signé, lie les Parties. Dans le cas d'une signature transmise par télécopie/e-mail, ou en fichier PDF envoyé par courrier électronique, ladite signature constitue une obligation légale et exécutoire pour la partie exécutante ayant la même force et le même effet que si ce Contrat était un original.",
        other: "autre",
        "Type of agreement": "Type de contrat",
        "Name and characteristics of yacht": "Nom du yacht et caractéristiques",
        NAME: "NOM",
        "IMO N°": "N° IMO",
        "Length OA": "Longueur HT",
        From: "De",
        To: "À",
        "Exclusive agreement": "Mandat exclusif",
        Yes: "Oui",
        "The agent": "Le mandataire",
        Agent: "Mandataire",
        "Role of the agent": "Rôle du mandataire",
        broker: "courtier",
        "central agent": "agent central",
        stakeholder: "séquestre",
        "Delegated operation": "Opérations déléguées",
        "Finding clients": "Recherche de clients",
        "Negotiation of Transport / Charter Agreement":
          "négociation du contrat",
        "Drafting Transport / Charter Agreement": "établissement du contrat",
        "Yacht promotion and marketing docs":
          "Promotion du yacht & doc. commerciale",
        "Yacht deployment planning": "Programmation des navigations",
        "Transfer of money to the Stakeholder":
          "transfert des sommes vers Séquestre",
        "Transfer of money to the Principal":
          "transfert des sommes vers Transporteur",
        "Formation information of Customer (visas, vaccination, insurance, etc.)":
          "informations obligatoires au Client (visas, vaccination, assurances, etc.)",
        "Add other operation": "Ajouter une autre opération",
        "Other delegated operation": "Autres opérations déléguées",
        "Agent's bank details (if Stakeholder)":
          "Données bancaires du mandataire (si séquestre)",
        "Agent's insurance and financial guarantee (when applicable)":
          "Assurance et garantie financière du mandataire (le cas échéant)",
        "Agent's remuneration": "Rémunération du mandataire",
        "Specify currency": "Préciser la devise",
        "Agent's payment terms and conditions":
          "Modalités de paiement du mandataire",
        "Term of the Agreement": "Période du contrat",
        Changes: "Changement",
        "The price of the Service is modified as follows":
          "Le prix de la Prestation est modifié comme suit",
        "Increase of cost": "Augmentation",
        "Reduction of cost": "Réduction",
        Currency: "Devise",
        "Base price (exc VAT)": "Base price (hors TVA)",
        "Other modifications": "Autres modifications",
        "Terms of additional payment": "Modalités de versement supplémentaire",
        Amount: "Montant",
        "Payment method": "Méthode de paiement",
        Comment: "Commentaire",
        "Add a port": "Ajouter un escale",
        "Add a passenger": "Ajouter un passager",
        Surname: "Nom",
        Nationality: "Nationalité",
        "Date of birth": "Date de naissance",
        "Place of birth": "Lieu de naissance",
        "Passport/ID n°": "N° passeport / ID",
        "Warning ! This part has to be filled before departure.":
          "Attention ! Cette partie doit être remplie avant le départ.",
        "There are errors in the following fields":
          "Il y a des erreurs sur les champs suivant",
        "Warning ! Base contract (page 1 to 4) has to be fully filled before signature.":
          "Attention ! Le contrat de base (pages 1 à 4) doit être complètement rempli avant la signature.",
        "Check a contract": "Vérifier un contrat",
        idem: "ex",
        "this argument should not contain any information about the version (v1 / v2 / ...).":
          "cet argument ne doit contenir aucune information sur la version",
        "You can put a real contract with some modified characters of the style 0c53938c-1dab-4e36-a009-39v9a72980ac":
          "tu peux mettre un vrai contrat avec quelques caractères modifiés du style 0c53938c-1dab-4e36-a009-39v9a72980ac",
        "don't enter version information (v1 / v2 / ...)":
          "ne pas saisir les informations de version (v1 / v2 / ...)",
        "Please enter the Agreement's unique number in order to verify if it was generated by our platform.":
          "Merci d'entrer le numéro d'identification unique du Contrat, afin de vérifier s'il a bien été généré par notre plateforme",
        "Agreement unique number": "Numéro d'identification du contrat",
        Check: "Vérifier",
        "This agreement has been generated by ECPY transport and charter agreements platform. It has been created by":
          "Cet accord a été généré par la plate-forme d'accord de transport ECPY. Il a été créé par",
        "This agreement has been generated by the platform.":
          "Ce contrat a été généré par la plateforme.",
        "Reset my crypt keys": "Réinitialiser mes clés de cryptage",
        "You are the main broker of this company":
          "Vous êtes le courtier principal de cette société",
        Unlimited: "Illimité",
        "Subscription end date": "Date de fin d'abonnement",
        "Update company": "Modifier la société",
        "Registration number": "Numéro d'enregistrement",
        "Registration country:": "Pays d'enregistrement",
        "VAT number": "Numéro TVA",
        "Back to draft": "Repasser en brouillon",
        "Share contract": "Partager un contrat",
        "You want to share a contract with another user of the platform. Please fill his email":
          "Vous souhaitez partager un contrat avec un autre utilisateur de la plateforme. Merci de renseigner son email",
        "User's email": "Email de l'utilisateur",
        "Contract has been shared to": "Le contrat a été partagé avec",
        "Contract has been duplicated": "Le contrat a été dupliqué avec succès",
        "Shared by": "Partagé par",
        "This contract has been shared to you. You can't update the data.":
          "Ce contrat est partagé avec vous, vous ne pouvez pas le modifier.",
        See: "Visualiser",
        "APPENDIX I - ITINERARY - PASSENGERS - AMENDMENTS":
          "ANNEXE I - ITINERAIRE - PASSAGERS - MODIFICATIONS",
        "ITINERARY - PASSENGERS - AMENDMENTS":
          "ITINERAIRE - PASSAGERS - MODIFICATIONS",
        "APPENDIX I": "ANNEXE I",
        "APPENDIX II": "ANNEXE II",
        ITINERARY: "ITINERAIRE",
        "CRUISING AREA": "ZONE DE NAVIGATION",
        "Date - Time of Arrival": "Jour - Heure d'arrivée",
        "Date - Time of Departure": "Jour - Heure de départ",
        Arrival: "Arrivée",
        Departure: "Départ",
        "PASSENGER LIST": "Liste des passagers",
        "Appendix I - RIDER TO THE AGREEMENT WITHOUT MODIFICATION OF CONTRACTUAL PRICE":
          "Annexe I - AVENANT AU CONTRAT SANS MODIFICATION DE COUT DU TRANSPORT",
        "RIDER TO THE AGREEMENT WITHOUT MODIFICATION OF CONTRACTUAL PRICE":
          "AVENANT AU CONTRAT SANS MODIFICATION DE COUT DU TRANSPORT",
        "RIDER TO THE AGREEMENT WITHOUT MODIFICATION OF CONTRACTUAL PRICE (CONT’D)":
          "AVENANT AU CONTRAT SANS MODIFICATION DE COUT DU TRANSPORT (CONT’D)",
        "Table of changes during the cruise, representing a rider to the Agreement without impact on the contractually agreed price":
          "Tableau des modifications en cours de voyage, valant avenant au contrat sans impact sur le coût du transport",
        "1. Change/s of port/s of call": "1. Changement(s) d'escale(s)",
        "CHANGES OF PORTS OF CALL": "CHANGEMENT D'ESCALES",
        "(Please indicate the port/s of call which have been cancelled, replaced and/or added and initial - Client and Captain)":
          "(indiquer ici les escales annulées, remplacées et ajoutées et parapher Client / Capitaine",
        "(Indicate the port/s of call which have been cancelled, replaced and/or added and initial - Client and Captain)":
          "(Indiquer ici les escales annulées, remplacées et ajoutées et parapher Client / Capitaine)",
        "(Indicate the initial embarkation and successive embarkations/disembarkations and initial - Client and Captain)":
          "(Indiquer ici les embarquements initiaux et les débarquements / embarquements successifs et parapher Client - Capitaine)",
        "Initial here": "Parapher ici",
        "(Please indicate the initial embarkation and successive embarkations / disembarkations and initial - Client and Captain for each change)":
          "(indiquer ici les embarquements initiaux et les débarquements / embarquements successifs et parapher Client - Capitaine",
        "Fields with * are mandatory": "Les champs * sont obligatoires",
        "valid format xx.xx": "Format xx.xx",
        "This field is required.": "Champs requis.",
        "Port (cancelled, replaced and/or added)":
          "Port (annulé, remplacé et/ou ajouté)",
        "2. Initial embarkation and embarkations/disembarkations during the voyage":
          "2. Embarquement initial et embarquements/débarquements pendant le voyage",
        "INITIAL EMBARKATION AND EMBARKATIONS/DISEMBARKATIONS DURING THE VOYAGE":
          "EMBARQUEMENT INITIAL ET EMBARQUEMENTS/DÉBARQUEMENTS PENDANT LE VOYAGE",
        "Add an item": "Ajouter un article",
        "Initial embarkation of Mr/Ms ": "Premier embarquement de Mr/Mme",
        Disembarkations: "Débarquements",
        Embarkations: "Embarquements",
        //Owner: "Propriétaire",
        //Charterer: "Locataire",
        Other: "Autre",
        "Add a line": "Ajouter une ligne",
        "Date of Agreement": "Date du contrat",
        New: "Nouveau",
        "Warning : don't enter version information (v1 / v2 / ...)":
          "Attention, en renseignez pas la version (v1 / v2 / ...)",
        "TRANSPORT AND SERVICES AGREEMENT FOR YACHTS":
          "CONTRAT DE TRANSPORT ET DE PRESTATIONS AU YACHTING",
        "This Agreement is the property of ECPY. Any reproduction, in part or in full, any distribution or use without the formal agreement in writing of this Association is strictly forbidden. All rights reserved.":
          "Ce contrat est la propriété d'ECPY. Toute reproduction, partielle ou complète, toute diffusion ou utilisation sans l'accord exprès et par écrit de cette association est strictement interdite. Tous droits réservés.",
        "PLEASE INITIAL": "VEUILLEZ PARAPHER",
        "SERVICE PROVIDER": "PRESTATAIRE",
        CLIENT: "CLIENT",
        "Maximum number of Passengers with staterooms (":
          "Nombre maximum de Passagers logeant avec couchette (",
        ") and day Passengers on board (":
          ") et de Passagers embarqués non logeant (",
        "Total price for Service Package - Voyage, Services and Accomodation":
          "Prix total de la Prestation / Voyage et Hébergement forfaitaires",
        "AGREEMENT ON DETAILED ITINERARY":
          "Accord Client-Capitaine sur le détail de l'itinéraire",
        CAPTAIN: "CAPITAINE",
        Agreement: "Contrat",
        "My agreements": "Mes contrats",
        "Check agreement": "Vérifier contrat",
        "Your agreements": "Vos contrats",
        "ECPY reminds you that the captain should have full contract build in one document":
          "ECPY rappelle que le capitaine doit disposer du contrat complet formé en un seul document",
        "4 first pages of the contract, with signatures,":
          "les 4 premières pages descriptives du contrat, avec signatures,",
        "appendix I with detailled itinerary and passengers list, fixed at departure (pp 5-7)":
          "l'appendice I avec l'itinéraire détaillé et la liste des passagers, tels que fixés au départ (pp 5-7)",
        "optional modifications to itinerary and passengers list with Client and Captain paraphs (pp 8-9)":
          "les éventuelles modifications à l'itinéraire et à la liste des passagers avec paraphe du Client et du capitaine (pp 8-9)",
        'In order to do that, you have to use the "Create the full PDF" feature, stricly regarding the previous recommandations.':
          'Pour cela, il convient d\'utiliser la fonction "Générer le contrat complet" et de le faire en respectant strictement les recommandations ci-dessus.',
        "Mail or alone page, non attached to the contrat and not signed, is not a relevant element nor modification legally accepted.":
          'Un mail ou une page "volante", non jointe au contrat et non signée, ne constitue pas un élément ni une modification recevable par les autorités.',
        "Thanks, your message has been sent. We'll come back to you as soon as possible.":
          "Merci, votre message a bien été envoyé. Nous reviendrons vers vous au plus vite.",
        "Your message has been sent": "Votre message a été envoyé",
        "Support contact form": "Support - Formulaire de contact",
        "Your email": "Votre email",
        "Your name": "Votre nom",
        "Your problem is about": "Votre problème concerne",
        "Financial aspects of the contract":
          "Les aspects financiers du contrat",
        "Platform use": "L'utilisation de la plateforme",
        "Technical issue with the platform":
          "Un problème technique avec la plateforme",
        "Your message": "Votre message",
        Attachment: "Pièce jointe",
        Browser: "Chercher",
        Send: "Envoyer",
        "DUPLICATE CONTRACT": "DUPLIQUER CONTRAT",
        "Contract's name": "Nom du contrat",
        Cancel: "Annuler",
        Duplicate: "Dupliquer",
        "Embarkations/Disembarkations": "Embarquements/Désembarquements",
        "Change of ports": "Changement d'escales",
        Warning: "Attention",
        "Contact us": "Contactez-nous",
        "Ask to reset my keys": "Demander à réinitialiser mes clés",
        "To duplicate a new contract, you can give it a name. It would be used as a reference, and never shown to your client":
          "Pour dupliquer un nouveau contrat, vous pouvez lui donner un nom. Il serait utilisé comme référence et jamais montré à votre client",
        "the date is not included in the date of the contract.":
          "la date n'est pas comprise dans la date du contrat.",

        "you will initiate the creation of a new encryption key.This action will revoke your old key, which will no longer be usable. As a result, all the contracts generated by the old key will no longer be accessible. As for the old key, the new key must be kept carefully and securely.  This operation is irrevocable.":
          "vous allez initier la création d'une nouvelle clé de chiffrement. Cette action va révoquer votre ancienne clé, qui ne sera donc plus utilisable. De ce fait, tous les contrats générés par l'ancienne clé ne seront plus accessibles. Comme pour l'ancienne clé, la nouvelle clé devra être conservée précieusement et de manière sécurisée.  Cette opération est irrévocable.",
        "this value must be greater than 1":
          "cette valeur doit être supérieure à 1",
        //Add
        Company: "Société",
        Lastname: "Nom",
        "Medium yacht length": "Longueur moyenne",
        "Send welcome email": "Envoyer un e-mail de bienvenue",
        "Select...": "selectionner...",
        "CSV export": "Exportation CSV",
        "Companies list": "liste des entreprises",
        Search: "chercher",
        "Illimited tokens": "tokens illimités",
        Agreements: "Contrats",
        "Registration country": "Pays d'enregistrement",
        "ECPY TRANSPORT AND CHARTER AGREEMENTS PLATFORM":
          "Plateforme contrat ECPY",
        "Remove company": "Supprimer une entreprise",
        "You are about to remove a company. WARNING, this action cannot be undone.":
          "Vous êtes sur de supprimer une entreprise. ",
        "Do you confirm ?": "Vous confirmez ?",
        "Remove broker": "Supprimer un Courtier",
        "You're about to remove a broker. Be carefull, this action cannot be undone !":
          "Vous êtes sur de supprimer un Courtier.Attention, cette action est irréversible !",
        "This broker is the main broker of the company":
          "Ce courtier est le courtier principal de la société",
        "Reset broker keys": "Réinitialiser les clés de cryptage de courtier",
        "Reset password": "Réinitialiser le mot de passe",
        Active: "Actif",
        "Broker's list": "Liste des courtiers",
        "My Transport agreements": "Mes contrats de transport",
        "Shared contracts": "contrats partagé",
        "Change new contract name": "changer le nom du contrat ",
        "Same as Broker": "Le même que le courtier ",
        Notices: "Documents",
        "Name must be filled": "Le nom doit être rempli",
        "My Charter agreements": " Mes contrats d'affrètement",
        "This agreement has not been generated by the platform.":
          "Ce contrat n'a pas été généré par la plateforme.",
        "ECPY Transport and Charter Agreements Platform":
          "Plateforme de contrats de transport et d'affrètement ECPY",
        "Your contract is in Draft again.":
          "Votre contrat est à nouveau en brouillon.",
        "Your contract has been validated.": "Votre contrat a été validé.",
        "The contract is not valid": "Le contrat n'est pas valide",
        "Base contract has to be valid": "Le contrat de base doit être valide",
        "Day Passengers on board": "Passagers embarqués non logeant",
        "Fiscal category of the cruise": "Catégorie fiscale de la croisière",
        "Contract has been saved": "Le contrat a été enregistré",
        "Please wait...": "S'il vous plaît, attendez...",
        "You can't edit this contract anymore.":
          "Vous ne pouvez plus modifier ce contrat.",
        "Amount of payment": "Montant du paiement",
        "This agreement has been generated by ECPY transport and charter agreements platform. It has been created by  ":
          "Cet accord a été généré par la plate-forme d'accord de transport ECPY. Il a été créé par",
        "You're now logged out": "Vous êtes maintenant déconnecté",
        "You're now logged in": "Vous êtes maintenant connecté",
        "Contract has been added": "Le contrat a été ajouté",
        "Contract has been removed": "Le contrat a été supprimé",
        "Invalid credentials.": "Les informations d'identification invalides.",
        "Charterer Address": "Affréteur adresse",
        "The Shipowner": "L'Armateur",
        "Maximum number of non-accommodating passengers on board":
          "Nombre maximum de passagers non accommodants à bord",
        "Maximum number of passengers on board":
          "Nombre maxium de passagers à bord",
        "Company ID": "Identif. Prof. Société",
        "Initial embarkation of Mr/Ms": "Premier embarquement de Mr/Mme",
        "Owner Address": "Adresse de l'armateur",
        "Owner Company ID": "Identif. Prof. de Société du propriétaire ",
        "Owner insurance reference": "Référence assurance  de l'armateur",
        "Owner VAT reference": "Armateur n° tva",
        "AGENCY AGREEMENT FOR YACHTING SERVICES":
          "Mandat d'intermédiaire de prestation au yachting",
        "THE PRINCIPAL": "LE PRINCIPAL",
        "PRINCIPAL represented by": "PRINCIPAL représenté par",
        "2. Status of the Principal": "2.Statut du Principal",
        "3. Type of agreement": "3. type de contrat",
        "4. Name and characteristics of yacht":
          "4. Nom et caractéristiques du yacht",
        "5. Agreement term": "5. Terme du contrat",
        "6. Cruising area": "6. Zone de croisière",
        "8. Role of the agent (cf. details below)":
          "8. Rôle de l'agent (cf. détails ci-dessous)",
        "ADDITIONAL DETAILS REGARDING THE AGREEMENT":
          "DÉTAILS SUPPLÉMENTAIRES CONCERNANT L'ACCORD",
        "9. Delegated operations": "9. Opérations déléguées",
        "(when applicable)": "(le cas échéant)",
        "10. Agent's bank details (if Stakeholder)":
          "10. Coordonnées bancaires de l'agent (si partie prenante)",
        "11. Agent's insurance and financial guarantee":
          "11. Assurance et garantie financière de l'agent",

        "12. Agent's remuneration": "12. Rémunération de l'agent",
        "13. Agent's payment terms and conditions":
          "13. Conditions de paiement de l'agent",
        "FOR THE PRINCIPAL": "POUR LE PRINCIPAL",
        "FOR THE AGENT": "POUR L'AGENT",
        "1. PRINCIPAL": "1. PRINCIPAL",
        "I have read, understood and accept all of the terms of the agreement and the general conditions overleaf.":
          "J'ai lu, compris et accepté tous les termes de l'accord et les conditions générales au verso.",
        "Date, signature and stamp of the Principal":
          "Date, signature et cachet du Mandant",
        "This document, prepared and provided by ECPY to its members, creates a transparent intermediary agreement in view of the signature of Transport and Services Agreements for Yachts.":
          "Ce document, préparé et fourni par ECPY à ses membres, crée un accord intermédiaire transparent en vue de la signature des accords de transport et de services pour les yachts.",
        ' represented by "name, signatory\'s status, full address", duly authorized to represent the Principal for the signature of this document':
          'représenté par "nom, qualité de signataire, adresse complète", dûment habilité à représenter le Mandant pour la signature de ce document',
        // "European Charter by ECPY":"CONTRAT D'AFFRETEMENT AU YACHTING",
        //  "Most frequent particular clauses\n - Sanitary/COVID\n  - Visas\n - Children\n- Diving\n- Pets\n - Insurance\n- Pre/post delivery fees\n - Jurisdiction / applicable law\n - Static charter: commercial operation authorization/shooting\n- Limitation of time “en route” per 24 hours period":"Clauses particulières les plus fréquentes",
        "ECPY European Charter Agreement": "Contrat Européen de Charter ECPY",
        "ADDENDUM TO\n THE EUROPEAN YACHTING CHARTER AGREEMENT BY ECPY":
          "AVENANT AU CONTRAT DE CHARTER EUROPEEN AU YACHTING PAR ECPY",
        "This document modifies the European charter Agreement.":
          "Le présent document apporte une modification au contrat de charter européen.",
        "Further to the  European Charter Agreement signed on":
          "Suite au Contrat de charter signé le",
        "the Charterer": "l’Affréteur",
        "the Owner": "l’Armateur",
        "Information on the Agreement": "Renseignements relatifs au Contrat",
        "Term of the Agreement from": "Période du Contrat du",
        "The Charter Fee is modified as follows":
          "Le loyer d’affrètement est modifié comme suit",
        "Total price of the Charter after this addendum":
          "Prix total après avenant de l’Affrètement",
        "Total price of the Charter": "Prix total de l’Affrètement",
        "Total Charter Price": "Prix total de l’Affrètement",
        "TERMS OF ADDITIONAL PAYMENT": "MODALITES DE VERSEMENT SUPPLEMENTAIRE",
        "Broker's representative": "Représentant du Courtier ",
        "Central Agent's representative": "Représentant de l’Agent Central",
        "Stakeholder's representative": "Représentant du Séquestre",
        "The following elements of the European Charter Agreement are modified":
          "Les éléments suivants du contrat de charter sont modifiés",
        "Average duration of navigation (vessel underway)":
          "Durée moyenne de navigation effective",
        "hours (per 24 hours period)": "(heures) par période de 24 heures",
        "Total price for Charter":
          "Prix total de l’Affrètement / Voyage et Hébergement forfaitaires",
        "Represented by ": "Représenté par",

        "name, capacity of signature, full address":
          " nom, qualité du signataire, adresse complète",
        "duly authorised as the Service Provider's reprensentative for the signature of this Agreement":
          "dûment habilité à représenter celui-ci pour la signature du présent document",
        to: "au",
        'Represented by "name, capacity of signature, full address", duly authorised as the Client\'s reprensentative for the signature of this Agreement':
          "Représenté par « nom, qualité du signataire, adresse complète », dûment habilité à représenter celui-ci pour la signature du présent document",
        "Represented by \"name, capacity of signatory, full address\", duly authorised as the (respectively) Broker's, Central Agent's and Stakeholder's representative for the signature of this Agreement":
          "Représenté par « nom, qualité du signataire, adresse complète », dûment habilité à représenter celui-ci pour la signature du présent document",
        'Represented by "name, capacity of signature, full address", duly authorised as the Service Provider\'s reprensentative for the signature of this Agreement':
          "Représenté par « nom, qualité du signataire, adresse complète », dûment habilité à représenter celui-ci pour la signature du présent document",
        "EXC VAT": "H.T",
        "Check the document": "Vérifier le document",
        Complete: "Complet",
        Incomplete: "Incomplet",
        "Bank Address": "Banque adresse",
        "Total price for Charter (INCL VAT)":
          "Prix total de Charter (INCL VAT)",
        "Maximum number of passengers in port":
          "Nombre maximum de Passagers dans le port",
        "Delete an element": "Supprimer un élément",
        "Are you sure you want to permanently delete this element ?":
          "Voulez-vous vraiment supprimer cet élément de façon définitive ?",
        "You cannot delete a valid contract.":
          "Impossible de supprimer un contrat déjà validé.",
        "Name must be different": "Le nom doit être différent",
        "Create the full DRAFT": "Créer le DRAFT complet",
        "Forgot password ?": "Mot de passe oublié ?",
        "Enter your login and we will send you an email containing a new password.":
          "Saisissez votre identifiant de connexion et nous vous enverrons par e-mail un nouveau mot de passe.",
        "Email was successfully sent !":
          "Un e-mail de réinitialisation a été envoyé avec succès !",
        "Your email address": "Votre adresse e-mail",
        "Sign in": "Connexion",
        "Your password": "Votre mot de passe",
        "General terms and conditions": "Conditions générales",
        Transfer: "Transférer",
        "Contract is being transferred.": "Transfert du contrat en cours.",
        "Please wait a few moments.": "Merci de patienter quelques instants.",
        History: "Historique",
        "Flag state": "Pavillon",
        "Company address": "Société adresse",
        "Company VAT number": "Société N° TVA",
        "Company MYBA id": "Société ref. MYBA",
        "Company financial guarantee": "Société Garantie financière",
        "Company insurance reference": "Société Assurance",
        "Length overall": "Longueur Hors Tout",
        Shipowner: "Armateur",
        "Shipowner address": "Armateur adresse",
        "Shipowner Company ID": "Armateur Identif.prof.société",
        "Shipowner insurance reference": "Armateur Assurance",
        "Shipowner VAT number": "Armateur N° TVA",
        "Order Tokens": "Commander des Tokens",
        "Our packs": "Nos packs",
        Buy: "Commander",
        "New assigned agreements": "Nouveaux contrats assignés",
        "You have new assigned agreements that you need to confirm.":
          "Vous avez de nouveaux contrats assignés que vous devez confirmer.",
        "My vessels": "Mes navires",
        "Add a new vessel": "Ajouter un nouveau navire",
        "Save and define users": "Enregistrer et définir des utilisateurs",
        "Last modified": "Dernière modification",
        Vessel: "Navire",
        "You cannot associate a non-existent user with the vessel":
          "Vous ne pouvez pas associer un utilisateur inexistant au navire",
        Associate: "Associer",
        "An error has occurred. If the problem persists, please contact the administrator":
          "Une erreur est survenue. Si le problème persiste, veuillez contacter votre administrateur",
        "View associated users": "Voir les utilisateurs associés",
        "List of associated users": "Liste des utilisateurs associés",
        Fullname: "Nom complet",
        "Choose a vessel ...": "Choisissez un navire ...",
        "Edit vessel": "Éditer un navire",
        "Old agreements": "Anciens contrats",
        Filters: "Filtres",
        "Redirecting to Odoo... Please wait.":
          "Redirection vers Odoo en cours... Veuillez patienter.",
        "Agreement term": "Terme du contrat",
        "Save and close": "Enregistrer et fermer",
        "You will be redirected to the website www.ecpy.org. You will need to use your ECPY account password if different from your ECPY contract platform password.":
          "Vous allez être redirigé sur le site www.ecpy.org. Vous devrez utiliser le mot de passe de votre compte ECPY s'il est différent de votre mot de passe d'accès à la plateforme contrats ECPY.",
        "This date": "Cette date",
        ", and place": ", et lieu",
        "(you may refer to initial passengers by their number on passenger list)":
          "(vous pouvez vous référer aux passagers initiaux par leur numéro sur la liste des passagers)",
        PASSENGER: "PASSAGER",
        "FIRST NAME": "PRÉNOM",
        "LAST NAME": "NOM",
        NATIONALITY: "NATIONALITÉ",
        "DATE OF BIRTH": "DATE DE NAISSANCE",
        "PLACE OF BIRTH": "LIEU DE NAISSANCE",
        "PASSPORT/ID": "N° PASSPORT",
        "Registration number and country of incorporation":
          "Numéro d'immatriculation et pays de constitution",
        "Registered office address": "Adresse du siège social",
        "Initial embarkations": "Premier embarquement",
        "(vessel underway)": "(navire en route)",
        "This Agreement is provided in English, with a non-official version in French being available. In case of a dispute regarding the interpretation of Agreement, the sole English version, included its appendices, is regarded as the legal reference of Agreement.":
          "Ce Contrat est fourni en français, une version non officielle en anglais étant disponible. En cas de litige concernant l'interprétation du Contrat, la seule version française, y compris ses annexes, est considérée comme la référence juridique du Contrat.",
        "PASSENGER __index__": "PASSAGER __index__",
        "COMMERCIAL PRESENTATION OF THE VESSEL AND SCOPE OF SERVICES":
          "PRÉSENTATION COMMERCIALE DU NAVIRE ET PÉRIMÈTRE DES SERVICES",
        "Attach leaflet, brochure or website printout showing the commercial presentation of the vessel and services":
          "Joindre une brochure, un prospectus ou une impression du site web présentant la présentation commerciale du navire et des services",
        "You cannot share a vessel with yourself":
          "Vous ne pouvez pas partager un navire avec vous-même",
        "You cannot transfer a vessel to yourself":
          "Vous ne pouvez pas transférer un navire à vous-même",
      },
    },
  },
  //lng: localStorage.lang ? localStorage.lang : "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
